import {Component} from "@angular/core";

import {availableModels} from "../app.globals";

import {serviceBaseAddress} from "../app.globals";

@Component({
  selector: 'app-classifier-api',
  templateUrl: 'api.component.html'
})
export class ApiComponent {

  public servicebaseAddress = serviceBaseAddress;

  public availableModels = availableModels;

}
